module.exports = __webpack_public_path__ + "3a8e418457ea7e4774706ac956d1a0fb.jpg";